import React from 'react'
import styles from '../component/custom.module.css';
import Images from './Images';
import Nav from './Nav';



const Header = ({executeScroll}) => {
    return (
    <div className={styles.header_section}>
        <Nav executeScroll={executeScroll} />
    </div>
    
    );
  };
  
  export default Header;

